import styles from "../../styles/PrimaryButton.module.scss";

export default function PrimaryButton({
  children,
  className,
}: {
  children: string;
  className?: string;
}) {
  return (
    <button className={`${styles.button} ${className}`}>{children}</button>
  );
}
